module.exports = __webpack_public_path__ + "static/media/cbn-icon.3e21bb92.png";